// components/admin/AdminPreinscripciones.jsx
import React, { useState, useEffect } from 'react';
import api from '../../api/axios'; 
import './AdminPreinscripciones.css'; // ← Importante importar el CSS

const AdminPreinscripciones = ({ userSlug }) => { 
    const [preinscripciones, setPreinscripciones] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtroEstado, setFiltroEstado] = useState('');
    
    const cargarPreinscripciones = async () => {
        setLoading(true);
        try {
            const params = {};
            if (filtroEstado) params.estado = filtroEstado;
            if (userSlug) params.competencia_slug = userSlug;
            
            console.log("Enviando parámetros al backend:", params);
            const response = await api.get('/admin/preinscripciones', { params });
            console.log("Respuesta real del servidor:", response.data);

            if (response.data && Array.isArray(response.data.data)) {
                setPreinscripciones(response.data.data);
            } else if (response.data && Array.isArray(response.data.datos)) {
                setPreinscripciones(response.data.datos);
            } else if (Array.isArray(response.data)) {
                setPreinscripciones(response.data);
            } else {
                setPreinscripciones([]);
            }
            
        } catch (error) {
            console.error('Error cargando preinscripciones:', error);
            alert(`Error al cargar: ${error.response?.data?.error || error.message}`);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        cargarPreinscripciones();
    }, [filtroEstado, userSlug]);

    const verificarPago = async (id) => {
        try {
            const response = await api.post(`/admin/preinscripciones/${id}/verificar`, { 
                competencia_slug: userSlug 
            });
            if (response.data.success) {
                alert(response.data.message);
                cargarPreinscripciones();
            } else {
                alert(response.data.message);
            }
        } catch (error) {
            alert(error.response?.data?.error || 'Error al verificar pago');
        }
    };

    const cancelarPreinscripcion = async (id) => {
        if (!window.confirm('¿Seguro que deseas cancelar esta preinscripción?')) return;
        try {
            const response = await api.post(`/admin/preinscripciones/${id}/cancelar`, { 
                competencia_slug: userSlug 
            });
            if (response.data.success) {
                alert(response.data.message);
                cargarPreinscripciones();
            }
        } catch (error) {
            alert(error.response?.data?.error || 'Error al cancelar');
        }
    };

    return (
        <div className="admin-p-container">
            <header className="admin-p-header">
                <h2 className="admin-p-titulo">
                    Gestión de Preinscripciones 
                    <span className="admin-p-slug-badge">{userSlug || 'General'}</span>
                </h2>
            </header>
            
            <div className="admin-p-filtros-bar">
                <div className="admin-p-filtro-group">
                    <label className="admin-p-label">Filtrar por Estado:</label>
                    <select 
                        className="admin-p-select" 
                        value={filtroEstado} 
                        onChange={(e) => setFiltroEstado(e.target.value)}
                    >
                        <option value="">Todos los estados</option>
                        <option value="pendiente">Pendiente</option>
                        <option value="completado">Completado</option>
                        <option value="cancelado">Cancelado</option>
                    </select>
                </div>
                <button className="admin-p-btn-refresh" onClick={cargarPreinscripciones}>
                    🔄 Actualizar
                </button>
            </div>

            {loading ? (
                <div className="admin-p-loading">
                    <div className="admin-p-spinner"></div>
                    <p>Cargando preinscripciones...</p>
                </div>
            ) : preinscripciones.length === 0 ? (
                <div className="admin-p-empty">
                    <p>No se encontraron preinscripciones para este evento.</p>
                </div>
            ) : (
                <div className="admin-p-table-wrapper">
                    <table className="admin-p-tabla">
                        <thead>
                            <tr>
                                <th>ID QR</th>
                                <th>Competidor</th>
                                <th>Estado</th>
                                <th>Fecha Creación</th>
                                <th className="admin-p-th-acciones">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {preinscripciones.map(p => (
                                <tr key={p.id} className={`admin-p-row admin-p-row-${p.estado}`}>
                                    <td className="admin-p-td-qr">
                                        <code>{p.id_qr || '—'}</code>
                                    </td>
                                    <td className="admin-p-td-nombre">
                                        {p.nombre || 'Sin nombre'}
                                    </td>
                                    <td>
                                        <span className={`admin-p-badge admin-p-badge-${p.estado}`}>
                                            {p.estado ? p.estado.toUpperCase() : 'DESCONOCIDO'}
                                        </span>
                                    </td>
                                    <td className="admin-p-td-fecha">
                                        {p.fecha_creacion ? new Date(p.fecha_creacion).toLocaleString() : '—'}
                                    </td>
                                    <td className="admin-p-td-acciones">
                                        {p.estado === 'pendiente' ? (
                                            <div className="admin-p-acciones-group">
                                                <button 
                                                    className="admin-p-btn admin-p-btn-verificar" 
                                                    onClick={() => verificarPago(p.id)}
                                                    title="Verificar Pago"
                                                >
                                                    Verificar
                                                </button>
                                                <button 
                                                    className="admin-p-btn admin-p-btn-cancelar" 
                                                    onClick={() => cancelarPreinscripcion(p.id)}
                                                    title="Cancelar Preinscripción"
                                                >
                                                    Cancelar
                                                </button>
                                            </div>
                                        ) : (
                                            <span className="admin-p-no-acciones">—</span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default AdminPreinscripciones;